/**
* Selector for shopping cart reducer
*
* This function create an selector
*
*/

export const items = (state) => state.addItemsShoppingCartReducer.data;
